<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CDrT4V/tc-custom/9781439677018.jpg?1704886028160" alt="This image is the cover for the book Lansing and the Civil War, Civil War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lansing and the Civil War, Civil War Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Explore Lansing's role in the war to preserve the Union and end slavery When war erupted between North and South, the capital of Michigan was ready to serve. The population of Lansing in 1860 was only 3000, but by the spring of 1865, over 500 men from the Capital City had enlisted to fight. These citizen-soldiers left the farms, factories, shops and schools of their youths to fight to uphold the Union and end slavery. Many of these boys would be wounded, captured, or killed, and those fortunate enough to return, came home changed, permanently maimed, and often haunted men. Using primary sources, including letters and personal diaries, author Matthew J. VanAcker unfolds the story of uncommon valor that offers a glimpse into the lives of the soldiers, their families, and the city they left behind.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matthew VanAcker
      </h2>
      
      <p class="authorDescription body article">Born and raised in Lansing, Matthew J. VanAcker is the director and curator of Save the Flags, a project to research, display and conserve 240 battle flags carried by Michigan soldiers in the Civil War, the Spanish-American War and World War I. He also serves as the director of the Michigan State Capitol Tour and Education Service and as vice-president of the Michigan Civil War Association. He has spoken and written extensively about the Michigan State Capitol and the Capitol Battle Flag collection. He resides in West Lansing with his wife, Mary Kathleen, in an 1885 farmhouse where they raised their four children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e49d6518